import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import ControlGroup from './control_group';
import { describedById } from './input_commons';

class TextArea extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'TextArea';
  }

  render() {
    return (
      <ControlGroup
        className={this.props.className}
        style={this.props.style}
        label={this.props.label}
        helpBlockText={this.props.helpBlockText}
        id={this.props.id}
        a11yFormLabels={this.props.a11yFormLabels}
      >
        <textarea
          id={this.props.id}
          className={this.props.textareaClass}
          name={this.props.name}
          value={this.props.value}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          required={this.props.required}
          placeholder={this.props.placeholder}
          style={_.merge({ width: '100%' }, this.props.textareaStyle)}
          aria-describedby={describedById(this.props)}
        />
      </ControlGroup>
    );
  }
}
TextArea.defaultProps = {
  required: false,
  placeholder: null,
};

export default TextArea;
